// IMPORTANT: disabling eslint rules at the file is not recommended.
// this file is an exception because usePrefetch is an experimental function that uses dynamic code (but is at least isolated to this file)

/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react-compiler/react-compiler */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { QueryClientConfig, useQueryClient } from "@tanstack/react-query";

let intercept = 0;

export function addExperimentalCallback(
    config?: QueryClientConfig
): QueryClientConfig {
    config ??= {};
    config.defaultOptions ??= {};
    config.defaultOptions.queries ??= {};
    (config.defaultOptions.queries as any)._experimental_beforeQuery = (
        options: unknown
    ) => {
        if (intercept > 0) {
            throw options;
        }
    };
    return config;
}

/** EXPERIMENTAL FUNCTION THAT USES EXCEPTIONS TO INTERCEPT */
export function usePrefetch(...funcs: ((...args: any[]) => any)[]): void {
    "use no memo";

    const queryClient = useQueryClient();

    for (const func of funcs) {
        // intercept react-query useSuspenseQuery calls by throwing and extract the queryKey and queryFn
        intercept++;

        let options: any;
        try {
            func();
        } catch (x) {
            if (
                typeof x === "object" &&
                x &&
                "queryKey" in x &&
                "queryFn" in x
            ) {
                options = { queryKey: x.queryKey, queryFn: x.queryFn }; // only keep queryKey and queryFn
            }
        }

        intercept--;

        if (!options) {
            throw new Error(
                "intercept expected in usePrefetch but didn't happen"
            );
        }

        if (!queryClient.getQueryState(options.queryKey)) {
            void queryClient.prefetchQuery(options);
        }
    }
}
